<template>
  <v-dialog v-model="innerValue" persistent max-width="520px">
    <v-card class="rounded-xl">
      <div class="start-dialog-header">
        <div>
          <div class="start-dialog-title">Start Your Order</div>
          <div class="start-dialog-subtitle">
            Please enter your information to continue.
          </div>
        </div>

        <v-btn icon small @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="pa-4">
        <v-text-field
          v-model="form.name"
          label="Your Name"
          outlined
          dense
          :error-messages="errors.name"
        />

        <v-text-field
          v-model="form.businessName"
          label="Business Name"
          outlined
          dense
          :error-messages="errors.businessName"
        />

        <v-text-field
          v-model="form.phoneNumber"
          label="Phone Number"
          outlined
          dense
          :error-messages="errors.phoneNumber"
        />

        <v-text-field
          v-model="form.email"
          label="Email Address"
          outlined
          dense
          :error-messages="errors.email"
        />
      </v-card-text>

      <v-divider />

      <v-card-actions class="pa-4">
        <v-btn text @click="close">Cancel</v-btn>
        <v-spacer />
        <v-btn
          rounded
          :dark="darkMode"
          :color="buttonColor"
          :loading="loading"
          @click="submit"
        >
          Continue
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PublicCustomerStartDialog",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    buttonColor: {
      type: String,
      default: "primary",
    },
    darkMode: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        name: "",
        businessName: "",
        phoneNumber: "",
        email: "",
      },
      errors: {
        name: [],
        businessName: [],
        phoneNumber: [],
        email: [],
      },
    };
  },
  created() {
    const saved = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}publicOrderCustomer`
    );

    if (saved) {
      try {
        const parsed = JSON.parse(saved);

        this.form.name = parsed.name || "";
        this.form.businessName = parsed.businessName || parsed.name || "";
        this.form.phoneNumber = parsed.phoneNumber || "";
        this.form.email = parsed.email || "";
      } catch (e) {
        localStorage.removeItem(
          `${process.env.VUE_APP_STORAGE_PREFIX}publicOrderCustomer`
        );
      }
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  methods: {
    close() {
      this.innerValue = false;
    },

    validate() {
      this.errors = {
        name: [],
        businessName: [],
        phoneNumber: [],
        email: [],
      };

      if (!this.form.name) {
        this.errors.name = ["Name is required"];
      }

      if (!this.form.businessName) {
        this.errors.businessName = ["Business name is required"];
      }

      if (!this.form.phoneNumber) {
        this.errors.phoneNumber = ["Phone number is required"];
      }

      if (!this.form.email) {
        this.errors.email = ["Email is required"];
      } else if (!/.+@.+\..+/.test(this.form.email)) {
        this.errors.email = ["Enter a valid email"];
      }

      return !(
        this.errors.name.length ||
        this.errors.businessName.length ||
        this.errors.phoneNumber.length ||
        this.errors.email.length
      );
    },

    submit() {
      if (!this.validate()) return;

      localStorage.setItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}publicOrderCustomer`,
        JSON.stringify(this.form)
      );

      this.$emit("continue", {
        ...this.form,
      });

      this.innerValue = false;
    },
  },
};
</script>

<style scoped>
.start-dialog-header {
  padding: 18px 20px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  gap: 16px;
}

.start-dialog-title {
  font-size: 20px;
  font-weight: 900;
  color: #0f172a;
}

.start-dialog-subtitle {
  font-size: 13px;
  color: #64748b;
  margin-top: 2px;
}
</style>